/**
 * The one indeterminate indicator in the app.
 *
 * An arc rather than a ring of dots, sized in `em` so it matches whatever it
 * sits inside without a size prop at every call site. Under reduced motion the
 * base stylesheet stops the rotation, which would leave a static arc that
 * looks like a rendering error — so the arc becomes a full ring and pulses its
 * opacity instead, which still reads as "working" without spinning.
 */

import styles from "./Spinner.module.css";

export function Spinner({ className = "", label }) {
  return (
    <span
      className={`${styles.spinner} ${className}`.trim()}
      role={label ? "status" : undefined}
      aria-label={label}
      aria-hidden={label ? undefined : "true"}
    >
      <svg viewBox="0 0 16 16" fill="none" className={styles.svg}>
        <circle cx="8" cy="8" r="6.5" stroke="currentColor" strokeWidth="2" opacity="0.22" />
        <path
          d="M8 1.5a6.5 6.5 0 0 1 6.5 6.5"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          className={styles.arc}
        />
      </svg>
    </span>
  );
}
